module.exports = __webpack_public_path__ + "img/2.436e9a49.png";